// removed by extract-text-webpack-plugin
module.exports = {"container":"Coach-registration__container___2u_7z","bannerContainer":"Coach-registration__bannerContainer___36h6m"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Coach-register/Coach-registration.scss
// module id = 1571
// module chunks = 0